import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar/Sidebar";
import Head from "./head/Head";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import AppRoot from "./global/AppRoot";
import AppMain from "./global/AppMain";
import AppWrap from "./global/AppWrap";
import { PageSearchProvider } from "./header-search/PageSearchContext";

import FileManagerProvider from "../pages/app/file-manager/components/Context";
import WeighbridgeAutoSync from "../pages/dashboard_pages/weighbridge/WeighbridgeAutoSync";

const Layout = ({title, ...props}) => {
  return (
    <FileManagerProvider>
      <Head title={!title && 'Loading'} />
      <AppRoot>
        <AppMain>
          <WeighbridgeAutoSync />
          <Sidebar fixed />
          <AppWrap>
            <PageSearchProvider>
              <Header fixed />
                <Outlet />
              <Footer />
            </PageSearchProvider>
          </AppWrap>
        </AppMain>
      </AppRoot>
    </FileManagerProvider>
  );
};
export default Layout;
